import React from "react";
import { Box, Typography } from "@mui/material";
import GoalVideoComponent from "./GoalVideoComponent";

const Leaderboard = ({ goals, setTournamentData }) => {
  return (
    <Box className="leaderboard_wrapper club_leaderboard_wrapper">
      <Typography component="h1" className="title">
        Leaderboard
      </Typography>
      {Array.isArray(goals) && goals.length > 0 ? (
        <>
          <Box className="rank-logo">Rank</Box>
          {goals.map((ele, index) => {
            if (index == goals.length - 1) {
              return (
                <>
                  <GoalVideoComponent
                    key={index}
                    data={ele}
                    setTournamentData={setTournamentData}
                    index={index}
                  />
                </>
              );
            } else {
              return (
                <>
                  <GoalVideoComponent
                    key={index}
                    data={ele}
                    setTournamentData={setTournamentData}
                    index={index}
                  />
                </>
              );
            }
          })}
        </>
      ) : (
        <Box className="no-data-found">No Data Found</Box>
      )}
    </Box>
  );
};

export default Leaderboard;
